module.exports = __webpack_public_path__ + "static/media/warningIcon.34bc49be.svg";